export const LOGOUT = '@components/auth/LOGOUT'
export const SET_JWT_TOKEN = '@components/auth/SET_JWT_TOKEN'

export const logout = () => ({type: LOGOUT})

export const setJwtToken = (jwt) => ({
  type: SET_JWT_TOKEN,
  jwt
})
